export const EMPTY_UNSAVED_ENTITY_DETAIL_SUMMARY = {
  hasUnsaved: false,
  entityName: "",
  sections: [],
};

/** @deprecated Use EMPTY_UNSAVED_ENTITY_DETAIL_SUMMARY */
export const EMPTY_UNSAVED_RELATIONSHIP_SUMMARY =
  EMPTY_UNSAVED_ENTITY_DETAIL_SUMMARY;

/** @typedef {{ key: string, label: string, kind?: 'relationship' | 'attributes', adds?: string[], removeNames?: string[], changedFields?: string[] }} UnsavedEntityDetailSectionSummary */
/** @typedef {{ hasUnsaved: boolean, entityName: string, sections: UnsavedEntityDetailSectionSummary[] }} UnsavedEntityDetailSummary */

export const formatUnsavedEntityDetailHint = (summary) => {
  if (!summary?.hasUnsaved) return "";
  return (summary.sections || [])
    .map((section) => {
      if (section.kind === "attributes") {
        const fields = section.changedFields?.length
          ? section.changedFields.join(", ")
          : "unsaved edits";
        return `${section.label}: ${fields}`;
      }
      const bits = [];
      if (section.adds?.length) bits.push(`${section.adds.length} to add`);
      if (section.removeNames?.length) {
        bits.push(`${section.removeNames.length} to remove`);
      }
      return `${section.label}: ${bits.join(", ")}`;
    })
    .join(" · ");
};

/** @deprecated Use formatUnsavedEntityDetailHint */
export const formatUnsavedRelationshipHint = formatUnsavedEntityDetailHint;
